import { createNavigator, TabRouter } from "react-navigation";
import React, { Component } from "react";
import HomePage from "../scenes/Home";
import LoginPage from "../scenes/Login";
import MatchList from "../scenes/MatchList";
import Match from "../scenes/Match";
import NotFoundError from "../scenes/NotFoundError";
import { connect } from "react-redux";

class NavigatorFrame extends Component {
  render() {
    const { router, navState } = this.props;

    const ScreenView = router.getComponentForRouteName(
      navState.routes[navState.index].routeName
    );

    return <ScreenView />;
  }
}

const ConnectedAppFrame = connect(state => {
  return {
    navState: state.navigation
  };
})(NavigatorFrame);

export const routeConfigs = {
  Home: {
    screen: HomePage,
    path: '',
  },
  Login: {
    screen: LoginPage,
    path: 'login',
  },
  MatchList: {
    screen: MatchList,
    path: 'matches',
  },
  Match: {
    screen: Match,
    path: 'match/:id',
  },
  NotFound: {
    screen: NotFoundError,
    navigationOptions: {
      title: 'Page Not Found | React Navigation',
    },
  },
};

export const RootNavigator = createNavigator(
  TabRouter(routeConfigs)
)(ConnectedAppFrame);



// WEBPACK FOOTER //
// ./src/navigators/RootNavigator.js